import React from 'react'
import Header from 'components/headers/bulletins'
import CustomTabs from './customTabs'

const PromissoryDetails = () => {
    return (
        <div>
            <Header title="سفته الکترونیک" />
            <CustomTabs />
        </div>
    )
}

export default PromissoryDetails
